
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/terms",
      function () {
        return require("private-next-pages/[locale]/terms/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/terms"])
      });
    }
  